<template>
  <div class="center-container">
    页面正在开发中...
  </div>
</template>

<script>
export default {
  name: 'Test',
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.center-container {
  background-color: #fff;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
}
</style>
